<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-calendar-blank</v-icon>
                    <h6>LISTADO DE PERSONAL DE VACACIONES</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listadoP" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
            </v-data-table>
        </v-app>
    </div>
</template>


<script>
import axios from "../../axios-auth";
import Ver from "../Deposito/Visualizadorxls.vue";

export default {
    components: { Ver },
    data: (vm) => ({
        listadoP: [],
        loadtable: false,
        headers: [
            { text: "Legajo", value: "legajo", align: "center", sortable: false },
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Fecha salida", value: "fechad", align: "center", sortable: false },
            { text: "Fecha regreso", value: "fechah", align: "center", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                //this.usuario = this.$store.state.nombre.toString().trim();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;
            axios
                .get("/RRHH/ListadoVacaciones?", {
                })
                .then((response) => {
                    self.listadoP = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    console.log(error);
                });
        },
        vaciarModels() {
            this.listadoP = [];

        },
    },
};
</script>
